import React from "react";
import ajaxError from "../helpers/ajaxError";
import log from "../helpers/log";
import urlPrefetch from "../helpers/urlPrefetch";
import ResponsivePicture from "../helpers/ResponsivePicture.jsx";

class SearchResultsItem extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<li>
				<a href={this.props.url}>
					<ResponsivePicture
						key={this.props.url}
						route={this.props.img}
						imgClass={this.props.imgClass}
						type="search"
						isRetina={window.isRetinadisplay}
					/>
					{this.props.name}
					{this.props.extra ? (
						<div className={this.props.extra}>
							{this.props.extra == "quality"
								? null
								: `(${this.props.valextra})`}
						</div>
					) : null}
				</a>
			</li>
		);
	}
}

class SearchResultsBlock extends React.Component {
	constructor(props) {
		super(props);
		this.urlPrefetch = new urlPrefetch();
	}
	componentDidMount() {
		this.urlPrefetch.detectarSearch();
	}
	componentWillUnmount() {
		this.urlPrefetch.unbindSearch();
	}
	render() {
		var rows = [];
		this.props.options.forEach((option, key) => {
			rows.push(
				<SearchResultsItem
					url={option.url}
					key={key}
					imgClass={option.imgClass}
					img={option.img}
					name={option.name}
					extra={option.extra}
					valextra={option["extraValue"]}
				/>
			);
		});
		return (
			<div>
				<h3 className="Main-search-result-title">
					{this.props.title}
					{this.props.extra ? (
						<a href={this.props.extra.value}>{this.props.extra.name}</a>
					) : null}
				</h3>
				<ul className="Main-search-result-list">{rows}</ul>
			</div>
		);
	}
}
class Search extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			value: "",
			showResults: false,
			hasResults: false,
			results: [],
			isLoading: false,
			ieHack:
				$("body").hasClass("explorer-10") | $("body").hasClass("explorer-11")
		};
		this.mouseIsDownOnSearch = false;
		this.handleChange = this.handleChange.bind(this);
		this.mouseDownHandler = this.mouseDownHandler.bind(this);
		this.mouseUpHandler = this.mouseUpHandler.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
		this.handleFocus = this.handleFocus.bind(this);
		this.pageClick = this.pageClick.bind(this);
		this.triggerChange = this.triggerChange.bind(this);
		this.urlPrefetch = new urlPrefetch();
	}
	componentWillMount() {
		this.timer = null;
	}
	componentDidMount() {
		window.addEventListener("mousedown", this.pageClick, false);
	}

	pageClick(e) {
		if (this.mouseIsDownOnSearch) {
			return;
		}
		//console.log(e.target);
		if (!$(e.target).closest(".Main-search").length) {
			this.setState({ showResults: false });
		}
	}

	mouseDownHandler() {
		this.mouseIsDownOnSearch = true;
	}

	mouseUpHandler() {
		this.mouseIsDownOnSearch = false;
	}
	handleBlur(event) {
		const { currentTarget } = event;

		const { activeElement } = document;
		//log(__filename, { currentTarget });
		//log(__filename, { activeElement });
		setTimeout(() => {
			if (!this.mouseIsDownOnSearch && !currentTarget.contains(activeElement)) {
				this.setState({ showResults: false });
			}
		}, 0);
	}
	handleFocus(event) {
		this.setState({ showResults: true });
	}

	handleChange(event) {
		this.setState({ value: event.target.value });

		clearTimeout(this.timer);
		this.timer = setTimeout(this.triggerChange, window.search_timeout);
	}
	triggerChange() {
		var esto = this;
		if (this.state.value.length >= 3) {
			this.setState({
				isLoading: true
			});
			$.ajax({
				method: "GET",
				url: window.nocache_url + "/predictable.json",
				data: { term: this.state.value }
			})
				.done(data => {
					esto.setState({ results: data.results, hasResults: true });
				})
				.fail((jqXHR, textStatus, errorThrown) => {
					log(__filename, "Search Error");
					log(__filename, { textStatus });
				})
				.always(() => {
					esto.setState({
						isLoading: false
					});
				});
			this.urlPrefetch.fetchUrl("/search/" + this.state.value);
		}
	}
	handleSubmit(event) {
		window.location = "/search/" + this.state.value;
		event.preventDefault();
	}
	render() {
		var rows = [];
		if (this.state.hasResults) {
			this.state.results.forEach((result, key) => {
				rows.push(
					<SearchResultsBlock
						key={key}
						options={result.options}
						title={result.title}
						extra={result.titleExtra}
					/>
				);
			});
		}
		return (
			<div
				tabIndex="0"
				onBlur={this.handleBlur}
				onMouseEnter={this.mouseDownHandler}
				onMouseLeave={this.mouseUpHandler}
			>
				<form autoComplete="off" onSubmit={this.handleSubmit}>
					<input
						name="data[term]"
						autoComplete="off"
						value={this.state.value}
						onFocus={this.handleFocus}
						onChange={this.handleChange}
						placeholder={translate.search_games}
						className="search"
						type="text"
						id="term"
					/>
				</form>
				{this.state.showResults ? (
					<div className="Main-search-result">
						<i className="fa fa-caret-up" aria-hidden="true" />
						{this.state.hasResults ? (
							<div>{rows}</div>
						) : this.state.isLoading ? (
							<i className=" fa fa-circle-o-notch fa-spin fa-fw "></i>
						) : (
							<p className="loading">{translate.search_placeholder_text}</p>
						)}

						{this.state.ieHack ? (
							<iframe
								id="fake"
								frameBorder="0"
								width="1"
								height="1"
								src="about:blank"
							/>
						) : null}
					</div>
				) : null}
			</div>
		);
	}
}

export default Search;
